import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { useRecoilValue } from 'recoil';
import { useHandleLinksManually } from '@/hooks/useHandleLinksManually';
import { useOldChatScroll } from '@/hooks/useOldChatScroll';
import { isMfaSelector, variantSelector } from '@/state/config';
import { chatModalState, composeSelector, overviewSelector, } from '@/state/session';
import { ChatEvents } from '../ChatEvents/ChatEvents';
import { ChatFooter } from '../ChatFooter/ChatFooter';
import { TypingIndicator } from '../Message/TypingIndicator';
import { MessageInput } from '../MessageInput/MessageInput';
import { WaitingTime } from './WaitingTime/WaitingTime';
import styles from './ChatContainer.module.scss';
export const Chat = () => {
    const compose = useRecoilValue(composeSelector);
    const { messagesRef, bodyRef } = useOldChatScroll();
    const isMfa = useRecoilValue(isMfaSelector);
    const chatModal = useRecoilValue(chatModalState);
    const { waitingTime, queuePosition } = useRecoilValue(overviewSelector);
    const { handleLinkClick } = useHandleLinksManually();
    const { isNbg } = useRecoilValue(variantSelector);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: cn(styles.middleWrapper, {
                    [styles.isMfa]: isMfa,
                    [styles.modalActive]: chatModal,
                    [styles.isNbg]: isNbg,
                }), style: {
                    backgroundImage: isNbg ? `url(../../public/nbg.svg)` : 'none',
                }, children: [_jsxs("ul", { onClick: handleLinkClick, role: "presentation", ref: messagesRef, className: styles.messages, children: [_jsx(ChatEvents, {}), compose && (_jsx("span", { className: styles.typing, children: _jsx(TypingIndicator, {}) }))] }), _jsx("span", { className: styles.bodyRef, ref: bodyRef })] }), _jsxs(ChatFooter, { children: [_jsx(WaitingTime, { waitingTime: waitingTime, queuePosition: queuePosition }), _jsx(MessageInput, {})] })] }));
};
